<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" persistent max-width="1500">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
          <span class="subheadline">Informe/Auditoria Nuevo</span>
          <v-layout row wrap class="item-group">
            <v-flex>
              <v-autocomplete
                v-model="report"
                label="Tipo de Informe a Crear"
                required
                :error-messages="getRequiredErrors('report')"
                :items="reports"
                item-text="description"
                item-value="pk"
              ></v-autocomplete>
            <!--  <v-text-field
                v-model="descripcion"
                label="Nombre de Informe"
                placeholder=""
                required
                :error-messages="getRequiredErrors('descripcion')"
                @input="onDescriptionChange"
              ></v-text-field>-->
              <v-autocomplete
                v-model="club"
                label="Club"
                required
                :error-messages="getRequiredErrors('club')"
                :items="clubes"
                item-text="nombre"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-btn color="primary" @click="closeDialog">Volver</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="submit">Crear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../../mixins/createEntityMixin'

export default {
  mixins: [validationMixin, createEntityMixin],

  validations: {
    report: { required },
    // descripcion: { required },
    club: { required }
  },

  components: {},

  data () {
    return {
      dialog: false,
      createPath: 'informe-auditoria/create',
      isEditing: false,
      definicionPresentacion: null,
      reports: [],
      report: null,
      descripcion: null,
      clubes: [],
      club: null
    }
  },
  methods: {
    fetchDefiniciones () {
      this.axios
        .get('informe-auditoria/reportes', {
          params: {
            modulo: 1
          }
        })
        .then(response => {
          this.reports = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    isValidForm () {
      return !this.$v.$invalid
    },
    getPayload () {
      return {
        report: this.report,
        description: this.descripcion,
        club: this.club,
        type: 1
      }
    },
    showDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },
    onDescriptionChange (event) {
      this.descripcion = event
    },
    fetchClubes () {
      this.axios
        .get('informe-auditoria/clubes')
        .then(response => {
          this.clubes = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    postSuccessfulSubmit () {
      this.goBack()
      this.saving = false
    },
    goBack () {
      this.goBackConfirmed = true
      this.$router.go()
    }
  },
  created () {
    this.fetchDefiniciones()
    this.fetchClubes()
  }
}
</script>

<style>
.subheadline {
  color: lightslategray;
  font-size: 1.6em;
  color: rgb(60, 145, 197);
  padding-top: 1.5em;
  margin-top: 2em;
}
</style>
